/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('PlanningCtrl', function(
    $scope,
    $uibModal,
    $routeParams,
    $location,
    Planning,
    Event,
    ErrorHandler,
    ErrorThrower,
    Log,
    ngNotify,
    identity,
    user
) {
    let first                = true;
    const me                   = identity;
    $scope.student       = user;
    const errorManager         = new ErrorThrower;
    $scope.event_filter  = { };
    $scope.filter_length = 0;
    $scope.events        = [];

    const refetchEvents = () => $scope.my_calendar.fullCalendar('refetchEvents');

    const changedView = function(view) {
        let start_date;
        if (first) {
            if ($routeParams.time && ((start_date = new Date(view.start)).getTime() !== ($routeParams.time * 1000))) {
                $scope.my_calendar.fullCalendar('gotoDate', (new Date($routeParams.time * 1000)));
            }
            first = false;
            return;
        }
        $scope.event_filter = { };
        start_date          = new Date(view.start);
        return $location.search({
            view: view.name,
            time: start_date.getTime() / 1000
        });
    };

    const renderEvent = function(event) {
        let needle;
        if ((event == null) || (event.event == null)) { return; }
        if ((needle = event.event.event, Array.from(Object.keys($scope.event_filter)).includes(needle))) { return; }
        return $scope.event_filter[`${event.event.event}`] = true;
    };

    const eventClick = function(cal_event) {
        if (undefined === cal_event.event) { return; }

        let start = moment(cal_event.event.start).format('DD-MM-YYYY HH:mm:ss');
        let end   = moment(cal_event.event.end).format('DD-MM-YYYY HH:mm:ss');

        const blueNotifyPopup =  document.getElementsByClassName('ngn ng-scope')[0];
        if (cal_event.event.location.indexOf('meet') !== -1) {
            cal_event.event.location = cal_event.event.location.replace(/.*meet.google.com/, 'https://meet.google.com');
            blueNotifyPopup.onclick =
            () => window.location.href = cal_event.event.location;
            blueNotifyPopup.style.cursor = 'pointer';
        } else if (cal_event.event.location.indexOf('you') !== -1) {
            cal_event.event.location = cal_event.event.location.replace(/.*you/, 'https://you');
            blueNotifyPopup.onclick =
            () => window.location.href = cal_event.event.location;
            blueNotifyPopup.style.cursor = 'pointer';
        } else {
            blueNotifyPopup.onclick =  () => null;
            blueNotifyPopup.style.cursor = 'initial';
        }
        if ((cal_event.event.group != null) || ['presential', 'elearning'].includes(cal_event.event.type)) { return ngNotify.set(`\
${cal_event.event.name} pour ${cal_event.event.activity_name} ${cal_event.event.location},
du ${start} au ${end}\
`
        ); }

        const modal_instance = $uibModal.open({
            templateUrl: 'directives/widget/planning/modal-confirm-event.html',
            controller:  'ModalConfirmEventCtrl',
            resolve: {
                cal_event() { return cal_event; },
                student_event_conflicts() {
                    return $scope.events.filter(function(event) {
                        if ((event.type === 'presential') || (event.group == null)) { return false; }
                        ({
                            end
                        } = event);
                        ({
                            start
                        } = event);
                        return (moment(cal_event.event.end).isBetween(start, end, null, '[]') ||
                            moment(cal_event.event.start).isBetween(start, end, null, '[]'));
                    });
                },
                group_event_conflicts() {
                    return Event.getGroupSelectedEvent({
                        login: me.login,
                        event_date: cal_event.event.id}).$promise
                    .then(result => result).catch(() => []);
                }
            }});

        return $scope.$on('refetchEvents', () => refetchEvents());
    };

    const getEventStyle = event => [ // Magie CSS, on ajoute une classe event.type, et une classe pour savoir s'il faut s'inscrire ou non
        event.type,
        !Array.from(me.groups).includes('adm') && ($scope.student.login !== me.login) ? 'fc-limit' : 'fc-event',
        (null === event.group) && ('presential' !== event.type) ? 'registration-needed' : 'registered'
    ];

    const handleEvents = function(events, refreshEventList) {
        if (true === refreshEventList) {
            $scope.events = [];
        }
        const toFill = [];
        let container = null;

        events.forEach(function(event, index) {
            if (true === refreshEventList) {
                switch (true) {
                    case event.type === 'presential': $scope.events.push(event); break;
                    case (container == null): container = event; break;
                    case (container != null) && (container.event === event.event):
                        if (container.start > event.start) { container.start = event.start; }
                        if (container.end < event.end) { container.end = event.end; }
                        break;
                    case (container != null) && (container.event !== event.event):
                        $scope.events.push(container);
                        container = event;
                        break;
                }
                if ((index === (events.length - 1)) && (container != null)) {
                    $scope.events.push(container);
                }
            }

            if (($scope.event_filter[`${event.event}`] == null)) {
                $scope.event_filter[`${event.event}`] = true;
            }

            const d1       = moment(event.start, 'YYYY-MM-DD HH:mm:ss');
            const d2       = moment(event.end, 'YYYY-MM-DD HH:mm:ss');
            const end_diff = Math.max(d2.diff(d1, 'minutes'), 30);  // Minimum 30 min pour l'affichage

            // On fait une copie de event pour avoir la bonne valeur dans toFill parce que
            // sinon le event.end renvoit la date de fin du dernier créneau
            const true_event = angular.copy(event);
            if (true === $scope.event_filter[`${event.event}`]) {
                return toFill.push({
                    title:     `${event.activity_name}\n${event.name}\n${event.location}`,
                    event:     true_event,
                    allDay:    1 <= d2.diff(d1, 'days'),
                    start:     d1.format('YYYY-MM-DDTHH:mm:ss'),
                    end:       d1.add(end_diff, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
                    className: getEventStyle(event)
                });
            }
        });

        $scope.filter_length = Object.keys($scope.event_filter).length;

        return toFill;
    };


    $scope.event_sources = [
        {
            events(start, end, timezone, callback) {
                return Planning
                .query({
                    login: $scope.student.login,
                    start: moment(start).format('YYYY-MM-DD HH:mm:ss'),
                    end:   moment(end).format('YYYY-MM-DD HH:mm:ss')}).$promise
                .then(events => callback(handleEvents(events, true))).catch(ErrorHandler);
            }
        }, {
            events(start, end, timezone, callback) {
                return Log
                .getSchedules({
                    login: $scope.student.login})
                .$promise
                .then(function(data) {
                    let events = [];
                    for (var contract of Array.from(data.contracts)) {
                        events = events.concat(
                            contract.schedules.map(function(event) {
                                event.type          = 'elearning';
                                event.uv_name       = 'E-learning';
                                event.activity_name = 'E-learning';
                                event.location      = contract.company_name;
                                event.name          = 'Formation e-learning';
                                return event;})
                        );
                    }
                    return callback(handleEvents(events, false));}).catch(() => callback(handleEvents([], false)));
            }
        }
    ];

    const strCapitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

    // L'utilisation de l'etna-calendar amène des besoins de configuration
    // différents en fonction des applications. On a donc décidé d'inclure
    // un champs etna_config au calendar_options
    // permettant au module de s'adapter aux besoins.

    // contient les différentes options qui seront inclues dans le champs
    // etna_config
    const etna_calendar_config =
        {regroup_events: true};

    $scope.calendar_options = {
        googleCalendarApiKey: 'AIzaSyCYCiOUi7MA40Cb4jw9NY33pjI0B6lZknE',
        height:               513,
        editable:             false,
        defaultView:          $routeParams.view || 'agendaWeek',
        header: {
            left:   'month agendaWeek agendaDay',
            center: 'title',
            right:  'today prev,next'
        },
        viewRender:      changedView,
        eventRender:     renderEvent,
        monthNames:      moment.months().map(strCapitalize),
        monthNamesShort: moment.monthsShort().map(strCapitalize),
        dayNames:        moment.weekdays().map(strCapitalize),
        dayNamesShort:   moment.weekdaysShort().map(strCapitalize),
        titleFormat: {
            month: 'MMMM YYYY',
            week:  'D MMM YYYY',
            day:   'dddd D MMMM YYYY'
        },
        columnFormat: {
            month: 'ddd',
            week:  'dddd - D',
            day:   ''
        },
        firstDay: 1,
        buttonText: {
            today: 'aujourd\'hui',
            day:   'jour',
            week:  'semaine',
            month: 'mois'
        },
        allDayText:       'Journée',
        allDayDefault:    false,
        firstHour:        9,
        slotMinutes:      10,
        slotEventOverlap: false,
        minTime:          '07:00:00',
        maxTime:          '23:00:00',
        etna_config:      etna_calendar_config
    };

    if (($scope.student.login === me.login) || Array.from(me.groups).includes('adm')) {
        $scope.calendar_options.eventClick = eventClick;
    }

    return Planning
    .getPromoCalendar({
        login: $scope.student.login})
    .$promise
    .then(function(promo_calendar) {
        if ((promo_calendar.url == null)) { return; }

        return Array.from(promo_calendar.url).map((cal) =>
            $scope.event_sources.push({ url: cal }));})
    .catch(error => errorManager.minor(error.statusText));
});
